// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"43d86395","453":"169ce3a7","455":"ed464118","977":"347aa877"}[chunkId] + ".chunk.js";
};